import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<g clip-path=\"url(#flag-zh_svg__a)\"><rect width=\"16\" height=\"16\" fill=\"#F5222D\" rx=\"2\"></rect><path fill=\"#FFC53D\" d=\"M4 6.97 2.15 8l.35-2.17L1 4.29l2.07-.31L4 2l.93 1.98L7 4.29 5.5 5.83 5.85 8 4 6.97ZM9.5 6.66 8.88 7 9 6.28l-.5-.52.7-.1.3-.66.3.66.7.1-.5.52.12.72-.62-.34ZM7.5 8.66 6.88 9 7 8.28l-.5-.52.7-.1.3-.66.3.66.7.1-.5.52.12.72-.62-.34ZM9.5 3.66 8.88 4 9 3.28l-.5-.52.7-.1.3-.66.3.66.7.1-.5.52.12.72-.62-.34ZM7 2.16l-.62.34.12-.72-.5-.52.7-.1L7 .5l.3.66.7.1-.5.52.12.72L7 2.16Z\"></path></g><defs><clipPath id=\"flag-zh_svg__a\"><path fill=\"#fff\" d=\"M0 0h16v16H0z\"></path></clipPath></defs>", 2)
  ])))
}
export default { render: render }